<template>
  <div class="wf-page-content">
    <WfIcon icon="layers-selected" />
    <p>
      <strong>Layers selected</strong>
      Now go ahead and retrieve their details before syncing them to Webflow.
    </p>
  </div>
</template>
<script>
import WfIcon from '@/components/WfIcon.vue';
export default {
  components: {
    WfIcon,
  },
};
</script>
